import React from 'react';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
var IndicatorForDeviationThumb = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var _b = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPremium = _b.isPremium, isPaidFolder = _b.isPaidFolder, isWatchToAccess = _b.isWatchToAccess;
    var isInTier = useSubscriptionTier(deviation).isInTier;
    var indicator;
    if (isPremium) {
        if (isPaidFolder) {
            indicator = React.createElement(Premium, { size: IconSize.SMALL });
        }
        else if (isWatchToAccess) {
            indicator = React.createElement(EyeDisc2, { size: IconSize.SMALL });
        }
    }
    else if (isInTier) {
        indicator = React.createElement(PromoBadge, { badgeType: "tier", size: 16 });
    }
    return indicator ? React.createElement("div", { className: className }, indicator) : null;
};
IndicatorForDeviationThumb.displayName = 'IndicatorForDeviationThumb';
export default IndicatorForDeviationThumb;
//# sourceMappingURL=IndicatorForDeviationThumb.js.map